export default __webpack_public_path__ + "static/media/my3dvision_logo.f63036b1.png";